import React from "react";
import "./Content.css";
import { useEffect ,useState} from "react";
import {init} from 'ityped';

const textArray = ["I am an ENTC Engineering student at VIT Pune currently in my 3rd year","I love spending time making Web Apps","I also love making native Android and IOS apps"];

function Content() {

    const [idx,setidx]=useState(0);

    useEffect(() => {
        setInterval(()=>{
            let curridx=idx;
            setidx(curridx+1);
        },7000);
       
    }, [idx])

    var textThatChanges = textArray[idx % textArray.length];

  return (
    <div className="content">
      <h1 className="heading">Hello !</h1>
      <p>My Name is Sarang Rajurkar.</p>
      <p >{textThatChanges}</p>
      <p>
        I am a budding engineer, working hard to pursue my dreams. </p>
        <p>I have a
        great zeal to learn and to put all my skills </p>
        <p>and knowledge to get the
        best of my work done.
      </p>


      <p>Also, being a keen learner and a youngster, I can work to the best of my potential in a faster and in a more relevant manner.</p>
    </div>
  );
}

export default Content;
